module.exports = __webpack_public_path__ + "media/Audio18_e.e250995a.wav";